import { api } from "../intreceptor/apiInterceptor";

export interface Local {
    id: string;
    code: string;
    unionNumber: number;
    created_at: string;
    updated_at: string;
    province: Province; // Added province property
}

export interface Province {
    id: string;
    name: string;
    created_at: string;
    updated_at: string;
}

export interface Sector {
    id: string;
    name: string;
    description: string | null;
    created_at: string;
    updated_at: string;
}

export interface Industry {
    id: string;
    name: string;
    description: string | null;
    created_at: string;
    updated_at: string;
    sector: Sector;
}

export interface FundingRes {
    id: string;
    name: string;
    created_at: string;
    updated_at: string;
}

export interface JobCompStatus {
    id: string;
    status: string;
    created_at: string;
    updated_at: string;
}

export interface Trade {
    id: string;
    // category: 'UA' | 'NON-UA';
    name: string;
    category?: string;
    description: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface Organizers {
    id: string;
    name: string;
    email: string;
    mobileNumber: string;
    gender: string;
    status: string;
    created_at: string;
    updated_at: string;
    refreshToken: string | null;
    lastLogin: string;
    lastLogout: string;
    role: {
        id: string;
        roleName: string;
        description: string;
        created_at: string;
        updated_at: string;
    };
}



export const lookupService = {
    async getLocals(): Promise<Local[]> {
        return api.fetch('/lookup/getlocals');
    },

    async getProvinces(): Promise<Province[]> {
        return api.fetch('/lookup/getProviences');
    },
    async getcontractorProvinces(): Promise<Province[]> {
        return api.fetch('/lookup/contractorProvince');
    },

    async getSectors(): Promise<Sector[]> {
        return api.fetch('/lookup/getsectors');
    },

    async getIndustries(): Promise<Industry[]> {
        return api.fetch('/lookup/getIndustries');
    },

    async getFundingRes(): Promise<FundingRes[]> {
        return api.fetch('/lookup/getFundingRes');
    },

    async getJobCompStatus(): Promise<JobCompStatus[]> {
        return api.fetch('/lookup/getJobCompStatus');
    },

    async getTrades(): Promise<Trade[]> {
        return api.fetch('/lookup/getTrades');
    },

    async getOrganizers(): Promise<Organizers[]> {
        return api.fetch('/lookup/getUsers');
    },

    async getFilteredOrganizers(): Promise<Organizers[]> {
        return api.fetch('/lookup/getFilteredOrganizers');
    },

    async getLocalUnionsFromVisits(): Promise<Local[]> {
        return api.fetch('/lookup/get-local-unions-from-visits');
    },

    async getTradesFromVisits(): Promise<Trade[]> {
        return api.fetch('/lookup/get-trades-from-visits');
    }
};
